import { i18nMark } from 'lingui-react';

const formattedMessages = {
  unitNumber: i18nMark('Unit Number'),
  vin: i18nMark('VIN'),
};

export default formattedMessages;



// WEBPACK FOOTER //
// ./containers/SearchContainer/messages.js